import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class RoleMgr extends Base {
  // 获取角色权限树
  public static getRoleTree() {
    return request.get(`/api/menu/tree`);
  }
  // 新建角色
  public static addRole(param: object) {
    return request.post(`/api/role`, param);
  }
  // 编辑角色
  public static updateRole(param: object) {
    return request.put(`/api/role`, param);
  }
  // 删除角色
  public static deleteRole(roleId: string) {
    return request.delete(`/api/role/${roleId}`);
  }
}
